import { Skeleton, Stack } from '@mui/material';
import type { FC } from 'react';

const OrderDocumentsSkeleton: FC = () => (
  <Stack gap={2} direction={'row'} flexWrap={'wrap'}>
    {[...Array(5)].map((_, i) => (
      <Skeleton key={i} variant='rounded' width={160} height={160} />
    ))}
  </Stack>
);

export default OrderDocumentsSkeleton;
